<div class="container"> 
  <img src="../../assets/shared/img/allya_bkg_optm.png" alt="Redirecionamento SSO"/>
  <div class="row">
    <div class="col-md-8 mx-auto message-redirect">  
      <h1>Cadastro não localizado, tente novamente ou entre em contato com a empresa.</h1>
      <div class="text-center">      
        <a href="http://colaboradores-site.herokuapp.com/entrar" class="btn button-redirect">Login</a>
      </div>
    </div>
  </div>
</div>